module.exports = __webpack_public_path__ + "static/media/1Thumbnail.edcb0a04.jpg";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/1Thumbnail.jpg
// module id = 1464
// module chunks = 33